var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.932 8.57797H27.52V8.02197C27.52 5.53797 25.504 3.52197 23.02 3.52197H14.413C11.928 3.52197 9.913 5.53797 9.913 8.02197V8.57797H4.5C2.015 8.57797 0 10.593 0 13.078V29.412C0 31.896 2.015 33.912 4.5 33.912H32.934C35.419 33.912 37.434 31.896 37.434 29.412V13.078C37.432 10.592 35.417 8.57797 32.932 8.57797ZM18.715 29.244C14.027 29.244 10.215 25.432 10.215 20.744C10.215 16.057 14.027 12.244 18.715 12.244C23.403 12.244 27.215 16.056 27.215 20.744C27.215 25.432 23.402 29.244 18.715 29.244ZM23.215 20.744C23.215 23.223 21.195 25.244 18.715 25.244C16.235 25.244 14.215 23.223 14.215 20.744C14.215 18.264 16.235 16.244 18.715 16.244C21.195 16.244 23.215 18.264 23.215 20.744Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default ForwardRef;